<template>
  <div class="p-manage-animal-group">
    <breadcrumb :items="breadcrumbs"></breadcrumb>

    <v-card color="transparent" flat>
      <v-toolbar color="transparent" flat>
        <v-toolbar-title>
          <p class="font-weight-bold">{{$t("geneticsAndBreeding.manageAnimalsGrouping")}}</p>
          <p style="font-size: 1rem">{{$t("geneticsAndBreeding.assignAnimalToContemporaryGroups")}}</p>
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-card class="group-stats">
          <v-card-text>
            <label class="text-h6 font-weight-boAssign Animal To Contemporary Groupsld">
              {{
                maintainanceMode == false ? "Reset Mode" : "Maintainance Mode"
              }}
              <v-tooltip right color="black" max-width="700">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="orange darken-2"
                    v-bind="attrs"
                    v-on="on"
                    size="20"
                    class="mb-1"
                  >
                    mdi-help-circle
                  </v-icon>
                </template>
                <span
                  v-html="
                    maintainanceMode == false
                      ? $t('manageAnimalGroupings.resetModeTooltip')
                      : $t(
                          'manageAnimalGroupings.maintainanceModeHeadingTooltip'
                        ).replace('\n', '<br>')
                  "
                ></span>
              </v-tooltip> </label
          ></v-card-text>
          <v-card-text>
            <div class="stat-details">
              <div class="total-animals">
                {{$t("geneticsAndBreeding.totalAnimals")}} -
                <span style="color: #0057bd">{{ totalAnimals }}</span>
              </div>
              <v-spacer />
              <div class="total-animals">
                {{$t("geneticsAndBreeding.assignAnimals")}} -
                <span style="color: #00bd73">{{ includedAnimalsCount }}</span>
              </div>
              <v-spacer />
              <div class="total-animals">
                {{$t("geneticsAndBreeding.excludedAnimals")}} -
                <span style="color: #f03737">{{ excludedAnimalsCount }}</span>
              </div>
              <v-spacer />
              <div class="total-animals">
                {{$t("geneticsAndBreeding.ungroupedAnimals")}} -
                <span style="color: #2193b0">{{ unGrouppedAnimalCount }}</span>
              </div>
            </div>
            <div class="actions" v-if="isModeLoaded">
              <v-btn
                v-if="maintainanceMode == false"
                @click="assignAnimalToCG"
                color="primary"
                class="mr-2"
                :disabled="!isResetToggleOn"
                >{{
                  !assignedToGroup ? "Assign Animals to CGs" : "Reset"
                }}</v-btn
              >

              <v-btn
                v-if="maintainanceMode"
                @click="enterResetMode"
                color="primary"
                class="mr-2"
                >{{ "Enter Reset Mode" }}
                <v-tooltip right color="black" max-width="700">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="orange darken-2"
                      v-bind="attrs"
                      v-on="on"
                      size="20"
                      class="mb-1"
                    >
                      mdi-help-circle
                    </v-icon>
                  </template>
                  <p
                    v-html="
                      $t('manageAnimalGroupings.resetModeTooltip').replace(
                        '\n',
                        '<br>'
                      )
                    "
                  ></p>
                </v-tooltip>
              </v-btn>
              <v-btn
                v-if="assignedToGroup && maintainanceMode == false"
                color="primary"
                @click="maintainanceModeConfirmationPopup = true"
                :disabled="!isResetToggleOn"
                >{{$t("geneticsAndBreeding.resetFinalized")}}

                <v-tooltip right color="black" max-width="700">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="white darken-2"
                      v-bind="attrs"
                      v-on="on"
                      size="20"
                      class="mb-1"
                    >
                      mdi-help-circle
                    </v-icon>
                  </template>
                  <span>{{
                    $t("manageAnimalGroupings.maintainanceModeTooltip")
                  }}</span>
                </v-tooltip>
              </v-btn>
              <v-card-text v-if="!isResetToggleOn">
                <span style="color: #f03737">{{
                  $t("manageAnimalGroupings.resetToggleTooltip")
                }}</span>
              </v-card-text>
              <v-checkbox
                label="Exclude Animals"
                v-model="excludeAnimal"
              ></v-checkbox>
            </div>
          </v-card-text>
        </v-card>

        <v-data-table
          :headers="headers"
          :items="animals"
          v-model="selected"
          show-select
          item-key="animalNumber"
          :items-per-page="10"
          :loading="loading"
          loading-text="Loading Animals... Please wait"
          hide-default-footer
          :options.sync="tableOptions"
          :server-items-length="totalRecords"
          :header-props="{
            'sort-icon': 'mdi-unfold-more-horizontal',
          }"
          v-show="excludeAnimal"
        >
          <template v-slot:top>
            <div class="d-flex mt-5 pt-3 ml-2">
              <v-text-field
                prepend-inner-icon="mdi-magnify"
                outlined
                height="5px"
                placeholder="Search by"
                dense
                v-model="search"
                class="shrink"
                @input="resetSearchOnEmpty"
                @keyup="searchEPDAnimal"
              ></v-text-field>

              <v-menu v-model="menu" :close-on-content-click="false">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    height="40"
                    width="40"
                    max-width="40"
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    class="ml-8"
                  >
                    <v-icon>mdi-filter-outline</v-icon>
                  </v-btn>
                </template>
                <v-card class="filter-modal">
                  <v-card-text>
                    <v-row>
                      <v-col cols="4" class="pl-5 pt-5">
                        <v-row>
                          {{$t("geneticsAndBreeding.byDate")}}
                          <v-radio-group
                            class="animal-filter-by-date"
                            v-model="filterByDate"
                            dense
                            row
                          >
                            <!-- column -->
                            <v-radio label="Today" value="today"></v-radio>
                            <v-radio label="This Week" value="week"></v-radio>
                            <v-radio label="This Month" value="month"></v-radio>
                            <v-radio label="This Year" value="year"></v-radio>
                            <v-radio label="Custom" value="custom"></v-radio>
                          </v-radio-group>
                          <div v-if="filterByDate == 'custom'" class="custom">
                            <v-row>
                              <v-col>
                                <v-menu
                                  v-model="filterByFromDateMenu"
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  transition="scale-transition"
                                  offset-y
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      v-model="filterByFromDate"
                                      append-icon="mdi-calendar"
                                      outlined
                                      dense
                                      filled
                                      v-bind="attrs"
                                      v-on="on"
                                      label="From: "
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="filterByFromDate"
                                    @input="filterByFromDateMenu = false"
                                  ></v-date-picker>
                                </v-menu>
                              </v-col>
                              <v-col>
                                <v-menu
                                  v-model="filterByFromToMenu"
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  transition="scale-transition"
                                  offset-y
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      v-model="filterByToDate"
                                      append-icon="mdi-calendar"
                                      outlined
                                      dense
                                      filled
                                      v-bind="attrs"
                                      v-on="on"
                                      label="To: "
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="filterByToDate"
                                    @input="filterByFromToMenu = false"
                                  ></v-date-picker>
                                </v-menu>
                              </v-col>
                            </v-row>
                          </div>
                        </v-row>
                      </v-col>
                      <v-col cols="4">
                        <label>{{$t("geneticsAndBreeding.sortBy")}}:</label>
                        <v-select
                          :items="[
                            { text: 'Animal ID', value: 'animalNumber' },
                            { text: 'Tag #', value: 'tagNumber' },
                            { text: 'Gender', value: 'gender' },
                            { text: 'Birth Weight (kg)', value: 'birthWeight' },
                            {
                              text: 'Weaning Weight (kg)',
                              value: 'weaningWeight',
                            },
                            {
                              text: 'Yearning Weight (kg)',
                              value: 'yearningWeight',
                            },
                            {
                              text: 'Carcass Weight (kg)',
                              value: 'carcassWeight',
                            },
                          ]"
                          item-text="text"
                          item-value="value"
                          filled
                          label=""
                          dense
                          v-model="sortBy"
                        ></v-select>
                        <label>{{$t("geneticsAndBreeding.status")}}:</label>
                        <v-select
                          :items="[
                            { text: 'All', value: 'all' },
                            { text: 'Sick', value: 'sick' },
                          ]"
                          item-text="text"
                          item-value="value"
                          filled
                          label=""
                          dense
                          v-model="filterByStatus"
                        ></v-select>
                        <label>{{$t("geneticsAndBreeding.trait")}}:</label>
                        <v-select
                          :items="[
                            { text: 'All', value: 'all' },
                            { text: 'BW', value: 'BW' },
                          ]"
                          item-text="text"
                          item-value="value"
                          filled
                          dense
                          label=""
                          v-model="filterByTrait"
                        ></v-select>
                      </v-col>

                      <v-col cols="4">
                        <label>{{$t("geneticsAndBreeding.birthYear")}}</label>
                        <v-row>
                          <v-col cols="6">
                            <v-menu
                              v-model="filterByFromBirthDateMenu"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="filterByFromBirthDate"
                                  append-icon="mdi-calendar"
                                  outlined
                                  dense
                                  filled
                                  v-bind="attrs"
                                  v-on="on"
                                  label="From: "
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="filterByFromBirthDate"
                                @input="filterByFromBirthDateMenu = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="6">
                            <v-menu
                              v-model="filterByToBirthDateMenu"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="filterByToBirthDate"
                                  append-icon="mdi-calendar"
                                  outlined
                                  dense
                                  filled
                                  v-bind="attrs"
                                  v-on="on"
                                  label="From: "
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="filterByToBirthDate"
                                @input="filterByToBirthDateMenu = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                        </v-row>

                        <label class="right-label">{{$t("geneticsAndBreeding.birthWeight")}}</label>

                        <v-row>
                          <v-col>
                            <label>Min</label>
                            <v-text-field
                              type="number"
                              dense
                              filled
                              v-model="filterByBirthWeight.min"
                            ></v-text-field>
                          </v-col>
                          <v-col>
                            <label>Max</label>
                            <v-text-field
                              type="number"
                              dense
                              filled
                              v-model="filterByBirthWeight.max"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <label class="right-label">{{$t("geneticsAndBreeding.weaningWeight")}}</label>
                        <v-row>
                          <v-col>
                            <label>Min</label>
                            <v-text-field
                              type="number"
                              filled
                              dense
                              v-model="filterByWeaningWeight.min"
                            ></v-text-field>
                          </v-col>
                          <v-col>
                            <label>Max</label>
                            <v-text-field
                              type="number"
                              filled
                              dense
                              v-model="filterByWeaningWeight.max"
                            ></v-text-field>
                          </v-col>
                        </v-row>

                        <label class="right-label">{{$t('geneticsAndBreeding.yarningWeight')}}</label>
                        <v-row>
                          <v-col>
                            <label>Min</label>
                            <v-text-field
                              type="number"
                              filled
                              dense
                              v-model="filterByYearningWeight.min"
                            ></v-text-field>
                          </v-col>
                          <v-col>
                            <label>Max</label>
                            <v-text-field
                              type="number"
                              dense
                              filled
                              v-model="filterByYearningWeight.max"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <label class="right-label">{{$t('geneticsAndBreeding.carcassWeight')}}</label>
                        <v-row>
                          <v-col>
                            <label>Min</label>
                            <v-text-field
                              type="number"
                              dense
                              filled
                              v-model="filterByCarcassWeight.min"
                            ></v-text-field>
                          </v-col>
                          <v-col>
                            <label>Max</label>
                            <v-text-field
                              type="number"
                              dense
                              filled
                              v-model="filterByCarcassWeight.max"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color="success" outlined @click="resetFilter()">
                      {{$t('geneticsAndBreeding.reset')}}
                    </v-btn>
                    <v-btn color="success" @click="applyFilter()">
                      {{$t('geneticsAndBreeding.reset')}}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
              <v-spacer></v-spacer>
              <div class="py-1 title">
                {{ from }} - {{ to }} of {{ totalRecords }}
              </div>
              <v-btn
                class="mx-2"
                fab
                small
                outlined
                color="primary"
                :disabled="tableOptions.page <= 1"
                @click="pageChange(false)"
              >
                <v-icon dark> mdi-chevron-left </v-icon>
              </v-btn>
              <v-btn
                class="mx-2"
                fab
                small
                outlined
                color="primary"
                :disabled="tableOptions.page >= totalPages"
                @click="pageChange(true)"
              >
                <v-icon dark> mdi-chevron-right </v-icon>
              </v-btn>
              <v-btn
                @click="excludeSelectedAnimals"
                outlined
                color="error"
                class="mr-2"
              >
                {{$t('geneticsAndBreeding.excludedAnimals')}}
              </v-btn>
            </div>
          </template>
          <template v-slot:progress>
            <v-progress-linear
              color="primary"
              :height="8"
              indeterminate
            ></v-progress-linear>
          </template>
          <template v-slot:item.birthWeight="{ item }">
            <span>{{
              item && item.AnimalEpd ? item.AnimalEpd.birth_weight_kg : "-"
            }}</span>
          </template>
          <template v-slot:item.weaningWeight="{ item }">
            <span>{{
              item && item.AnimalEpd ? item.AnimalEpd.weaning_weight_kg : "-"
            }}</span>
          </template>
          <template v-slot:item.yearlingWeight="{ item }">
            <span>{{
              item && item.AnimalEpd ? item.AnimalEpd.yearling_weight_kg : "-"
            }}</span>
          </template>
          <template v-slot:item.carcassWeight="{ item }">
            <span>{{
              item && item.AnimalEpd ? item.AnimalEpd.carcass_weight : "-"
            }}</span>
          </template>
          <template v-slot:item.status="{ item }">
            <v-btn
              style="background: #e5f8f1"
              color="#00BD73"
              outlined
              rounded
              >{{ item.status || "N/A" }}</v-btn
            >
          </template>
        </v-data-table>

        <div
          v-if="
            assignedToGroup &&
            excludeAnimal == false &&
            unGrouppedAnimalCount > 0 &&
            maintainanceMode == false
          "
          class="my-2"
        >
          <v-alert prominent color="red lighten-4">
            <span style="color: #f03737">{{ unGrouppedAnimalCount }}</span>
            {{$t('geneticsAndBreeding.animalMissingMsg')}}
          </v-alert>
          <v-toolbar-title>
            <p class="font-weight-bold">{{$t("geneticsAndBreeding.listOfUngroupedAnimals")}}</p>
          </v-toolbar-title>
        </div>
        <v-data-table
          :headers="headers"
          :items="unGrouppedAnimals"
          v-model="unGrouppedSelected"
          show-select
          item-key="animalNumber"
          :items-per-page="10"
          :loading="loading"
          loading-text="Loading Ungroupped Animals... Please wait"
          hide-default-footer
          :options.sync="ungrouppedAnimalTableOptions"
          :server-items-length="ungrouppedTotalRecords"
          :header-props="{
            'sort-icon': 'mdi-unfold-more-horizontal',
          }"
          v-show="
            assignedToGroup &&
            excludeAnimal == false &&
            maintainanceMode == false
          "
        >
          <template v-slot:top>
            <div class="d-flex mt-5 pt-3 ml-2">
              <v-text-field
                prepend-inner-icon="mdi-magnify"
                outlined
                height="5px"
                placeholder="Search by"
                dense
                v-model="search"
                class="shrink"
              ></v-text-field>

              <v-spacer></v-spacer>
              <div class="py-1 title">
                {{ ungrouppedFrom }} - {{ ungrouppedTo }} of
                {{ ungrouppedTotalRecords }}
              </div>
              <v-btn
                class="mx-2"
                fab
                small
                outlined
                color="primary"
                :disabled="ungrouppedAnimalTableOptions.page <= 1"
                @click="ungrouppedPageChange(false)"
              >
                <v-icon dark> mdi-chevron-left </v-icon>
              </v-btn>
              <v-btn
                class="mx-2"
                fab
                small
                outlined
                color="primary"
                :disabled="
                  ungrouppedAnimalTableOptions.page >= ungrouppedTotalPages
                "
                @click="pageChange(true)"
              >
                <v-icon dark> mdi-chevron-right </v-icon>
              </v-btn>
              <v-btn color="primary" class="mr-2" @click="resendToUser">
                {{$t('geneticsAndBreeding.resendToUser')}}
              </v-btn>
            </div>
          </template>
          <template v-slot:progress>
            <v-progress-linear
              color="primary"
              :height="8"
              indeterminate
            ></v-progress-linear>
          </template>
          <template v-slot:item.birthWeight="{ item }">
            <span>{{
              item && item.AnimalEpd ? item.AnimalEpd.birth_weight_kg : "-"
            }}</span>
          </template>
          <template v-slot:item.weaningWeight="{ item }">
            <span>{{
              item && item.AnimalEpd ? item.AnimalEpd.weaning_weight_kg : "-"
            }}</span>
          </template>
          <template v-slot:item.yearlingWeight="{ item }">
            <span>{{
              item && item.AnimalEpd ? item.AnimalEpd.yearling_weight_kg : "-"
            }}</span>
          </template>
          <template v-slot:item.carcassWeight="{ item }">
            <span>{{
              item && item.AnimalEpd ? item.AnimalEpd.carcass_weight : "-"
            }}</span>
          </template>
          <template v-slot:item.status="{ item }">
            <v-btn
              style="background: #e5f8f1"
              color="#00BD73"
              outlined
              rounded
              >{{ item.status || "N/A" }}</v-btn
            >
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="submittingData" width="500">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{$t('geneticsAndBreeding.submittingData')}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeSubmittingDataDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <div class="my-2" style="margin: auto; width: 4rem">
            <v-img src="/img/fetchDialog.png" />
          </div>
          <v-row>
            <v-col cols="12">
              <div class="py-5 text-center">
                {{$t('geneticsAndBreeding.waitingIntoGroups')}}
              </div>
            </v-col>
          </v-row>
          <v-card-actions class="mt-2" style="padding-right: 0">
            <v-row>
              <v-col cols="12">
                <div class="py-5 text-center">
                  <v-btn
                    @click="closeSubmittingDataDialog"
                    outlined
                    color="primary"
                    class="mr-2"
                  >
                    {{$t('geneticsAndBreeding.ok')}}
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="resetConfirmationPopUp" width="500">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{$t('geneticsAndBreeding.Confirmation')}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeResetConfirmationPopUp">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <div class="py-5 text-center">
                <p>
                  {{$t('geneticsAndBreeding.resetMsg')}}
                </p>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <div class="py-5 text-center">{{$t('geneticsAndBreeding.doYouWantToProceed')}}</div>
            </v-col>
          </v-row>
          <v-card-actions class="mt-2" style="padding-right: 0">
            <v-row>
              <v-col cols="12">
                <div class="py-5 text-center">
                  <v-btn
                    @click="closeResetConfirmationPopUp"
                    outlined
                    color="error"
                    class="mr-2"
                  >
                    {{$t('geneticsAndBreeding.no')}}
                  </v-btn>
                  <v-btn
                    @click="assignGroup"
                    outlined
                    color="primary"
                    class="mr-2"
                  >
                    {{$t('geneticsAndBreeding.yes')}}
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="maintainanceModeConfirmationPopup" width="500">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title> {{$t('geneticsAndBreeding.confirmation')}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeMaintainanceModeConfirmationPopUp">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <div class="py-5 text-center">
                <p>
                  {{$t('geneticsAndBreeding.changeToMaintenanceModeMsg')}}
                </p>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <div class="py-5 text-center">{{$t('geneticsAndBreeding.doYouWantToProceed')}}</div>
            </v-col>
          </v-row>
          <v-card-actions class="mt-2" style="padding-right: 0">
            <v-row>
              <v-col cols="12">
                <div class="py-5 text-center">
                  <v-btn
                    @click="closeMaintainanceModeConfirmationPopUp"
                    outlined
                    color="error"
                    class="mr-2"
                  >
                    {{$t('geneticsAndBreeding.no')}}
                  </v-btn>
                  <v-btn
                    @click="changeToMaintainanceMode"
                    outlined
                    color="primary"
                    class="mr-2"
                  >
                    {{$t('geneticsAndBreeding.yes')}}
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AnimalService from "@/_services/AnimalService";
import EPDService from "@/_services/EPDService";
import moment from "moment";

export default {
  computed: {
    currentUser() {
      return this.$store.getters.getUser;
    },
    breadcrumbs() {
      return [
        {
          text: this.$t("dashboard"),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t("Genetic & Breeding"),
          disabled: true,
          to: "/",
        },
      ];
    },
  },
  data() {
    return {
      menu: false,
      animals: [],
      unGrouppedAnimals: [],
      filterByDate: "",
      filterByFromDate: "",
      filterByFromDateMenu: false,
      filterByToDate: "",
      filterByToDateMenu: false,
      filterByStatus: "",
      filterByTrait: "",
      filterByFromBirthDate: "",
      filterByFromBirthDateMenu: false,
      filterByToBirthDate: "",
      filterByToBirthDateMenu: false,
      filterByBirthWeight: { min: 0, max: 0 },
      filterByWeaningWeight: { min: 0, max: 0 },
      filterByYearningWeight: { min: 0, max: 0 },
      filterByCarcassWeight: { min: 0, max: 0 },
      sortBy: "",
      includedAnimals: [],
      includedAnimalsCount: 0,
      assignedToGroup: false,
      excludedAnimals: [],
      excludedAnimalsCount: 0,
      unGrouppedAnimalCount: 0,
      loading: false,
      search: "",
      selected: [],
      unGrouppedSelected: [],
      totalAnimals: 0,
      totalRecords: 0,
      totalPages: 0,
      to: 0,
      from: 0,
      ungrouppedTotalRecords: 0,
      ungrouppedTotalPages: 0,
      ungrouppedTo: 0,
      ungrouppedFrom: 0,
      excludeAnimal: false,
      firstFetch: false,
      headers: [
        {
          text: this.$t("Animal ID"),
          align: "start",
          value: "animalNumber",
          class: "black--text",
          sortable: true,
        },
        {
          text: this.$t("Tag #"),
          value: "tagNumber",
          class: "black--text",
          sortable: false,
        },
        {
          text: this.$t("Gender"),
          value: "gender",
          class: "black--text",
          sortable: true,
        },
        {
          text: this.$t("Birth Weight (kg)"),
          value: "birthWeight",
          class: "black--text",
          sortable: true,
        },
        {
          text: this.$t("Weaning Weight (kg)"),
          value: "weaningWeight",
          class: "black--text",
          sortable: true,
        },
        {
          text: this.$t("Yearling Weight (kg)"),
          value: "yearlingWeight",
          class: "black--text",
          sortable: true,
        },
        {
          text: this.$t("Carcass Weight (kg)"),
          value: "carcassWeight",
          class: "black--text",
          sortable: true,
        },
        {
          text: this.$t("Status"),
          value: "status",
          class: "black--text",
          sortable: false,
        },
      ],
      submittingData: false,
      resetConfirmationPopUp: false,
      maintainanceModeConfirmationPopup: false,
      tableOptions: {},
      ungrouppedAnimalTableOptions: {},
      filterParams: {},
      maintainanceMode: false,
      isModeLoaded: false,
      isResetToggleOn: false,
    };
  },
  methods: {
    closeSubmittingDataDialog() {
      this.submittingData = false;
    },
    openResetConfirmationPopUp() {
      this.resetConfirmationPopUp = true;
    },
    closeResetConfirmationPopUp() {
      this.resetConfirmationPopUp = false;
    },
    closeMaintainanceModeConfirmationPopUp() {
      this.maintainanceModeConfirmationPopup = false;
    },
    assignAnimalToCG() {
      if (this.assignedToGroup == true) {
        this.openResetConfirmationPopUp();
      } else {
        this.assignGroup();
      }
    },
    async assignGroup() {
      if (this.resetConfirmationPopUp == true) {
        this.closeResetConfirmationPopUp();
      }
      this.submittingData = true;

      // this.assignedToGroup = false;

      try {
        await AnimalService.assignAnimalToGroup(this.excludedAnimals).then(
          async res => {
            if (res.success) {
              const animalIds = res.data;
              if (!animalIds?.length) {
                this.$notify({
                  title: "Animal assign to CGs",
                  text: "No animals to assign to CGs",
                  type: "error",
                });
                return;
              }
              await EPDService.assignAnimalsToGroup({
                userId: this.currentUser.id,
                animal_ids: animalIds,
                animalIds: animalIds,
              }).then(async res => {
                this.$notify({
                  title: "Animal assign to CGs",
                  text: res?.message || "Animal assigning to CGs started",
                  type: "success",
                });
                await this.updateStage("ASSIGNED_TO_GROUP");
              });
              this.assignedToGroup = true;
            } else {
              this.$notify({
                title: "Animal assign to CGs",
                text: res.message,
                type: "error",
              });
            }
          }
        );
      } catch (e) {
        console.log(e);
        this.$notify({
          title: "Animal assign to CGs",
          text: e?.message || "Error assigning animals to CGs",
          type: "error",
        });
      } finally {
        this.submittingData = false;
        this.excludeAnimal = false;
        this.getUnGrouppedAnimals();
      }
    },
    async getUnGrouppedAnimals() {
      try {
        await AnimalService.getUngrouppedAnimals(
          this.ungrouppedAnimalTableOptions
        )
          .then(async res => {
            console.log(res.data);
            if (res.success) {
              this.unGrouppedAnimals = res.data.rows;
              this.unGrouppedAnimalCount = res.data.count;
              this.ungrouppedTotalRecords = res.data.count;
              this.ungrouppedTotalPages = Math.ceil(
                this.ungrouppedTotalRecords /
                  this.ungrouppedAnimalTableOptions.itemsPerPage
              );
              this.ungrouppedFrom =
                (this.ungrouppedAnimalTableOptions.page - 1) *
                  this.ungrouppedAnimalTableOptions.itemsPerPage +
                1;
              this.ungrouppedTo =
                this.ungrouppedAnimalTableOptions.page *
                  this.ungrouppedAnimalTableOptions.itemsPerPage -
                (this.ungrouppedAnimalTableOptions.itemsPerPage -
                  res.data.returnedRecords);
              this.loading = false;
            }
          })
          .catch(err => {
            this.loading = false;
            console.log(err);
          });
      } catch (e) {
        console.log(e);
      }
    },
    async changeToMaintainanceMode() {
      try {
        await EPDService.changeToMaintainanceMode().then(async res => {
          console.log(res);

          this.$notify({
            title: "Maintainance Mode",
            text: res?.message || "Maintainance Mode",
            type: "success",
          });
          await this.updateStage("MAINTAINANCE_MODE");
          this.maintainanceMode = true;
        });
        this.maintainanceModeConfirmationPopup = false;
      } catch (e) {
        console.log(e);
        this.$notify({
          title: "Maintainance mode failed",
          text: e?.message,
          type: "error",
        });
      }
    },
    applyFilter() {
      const filtersData = {
        status: this.filterByStatus,
        trait: this.filterByTrait,
        dateFrom: this.filterByFromDate,
        dateTo: this.filterByToDate,
        birthDateFrom: this.filterByFromBirthDate,
        birthDateTo: this.filterByToBirthDate,
        birthWeigthMin: this.filterByBirthWeight.min,
        birthWeigthMax: this.filterByBirthWeight.max,
        weaningWeightMin: this.filterByWeaningWeight.min,
        weaningWeightMax: this.filterByWeaningWeight.max,
        yearningWeightMin: this.filterByYearningWeight.min,
        yearningWeigthMax: this.filterByYearningWeight.max,
        carcassWeigthMin: this.filterByCarcassWeight.min,
        carcassWeigthMax: this.filterByCarcassWeight.max,
      };
      const currentDate = moment();
      if (this.filterByDate === "today") {
        filtersData.dateFrom = this.formatDate(currentDate);
        filtersData.dateTo = this.formatDate(currentDate);
      }
      if (this.filterByDate === "week") {
        filtersData.dateTo = this.formatDate(currentDate.endOf("week"));
        filtersData.dateFrom = this.formatDate(currentDate.startOf("week"));
      }
      if (this.filterByDate === "month") {
        filtersData.dateTo = this.formatDate(currentDate.endOf("month"));

        filtersData.dateFrom = this.formatDate(currentDate.startOf("month"));
      }
      if (this.filterByDate === "year") {
        filtersData.dateTo = this.formatDate(currentDate.endOf("year"));
        filtersData.dateFrom = this.formatDate(currentDate.startOf("year"));
      }

      this.filterParams = filtersData;
      this.getAnimalsData();
      this.menu = false;
    },

    getAnimalsData() {
      this.loading = true;
      // add filters
      AnimalService.getAnimalForAssigningGroup(
        this.tableOptions,
        this.search,
        this.filterParams,
        this.excludedAnimals
      )
        .then(res => {
          console.log("sss", res);
          if (res.success) {
            if (!this.firstFetch) {
              this.includedAnimals = [
                ...this.includedAnimals,
                ...res.data.rows,
              ];
              this.includedAnimalsCount = res.data.totalRows;
              this.totalAnimals = res.data.totalRows;
            }
            this.animals = res.data.rows;

            this.totalRecords = res.data.totalRows;

            this.totalPages = Math.ceil(
              this.totalRecords / this.tableOptions.itemsPerPage
            );
            this.from =
              (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage + 1;
            this.to =
              this.tableOptions.page * this.tableOptions.itemsPerPage -
              (this.tableOptions.itemsPerPage - res.data.numRows);
            this.loading = false;
            this.firstFetch = true;
          }
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
          this.$notify({
            title: "Animal fetched failed",
            text: err?.message,
            type: "error",
          });
        });
    },
    async enterResetMode() {
      this.maintainanceMode = false;
      this.assignedToGroup = false;
      this.submittingData = false;
      this.excludeAnimal = true;
      await this.updateStage("RESET_MODE");
    },

    async getStage() {
      await AnimalService.getManageAnimalStage()
        .then(res => {
          if (res.success) {
            this.isResetToggleOn = res.data.resetToggle;
            if (res.data?.stage) {
              const stage = res.data?.stage;
              if (stage == "ASSIGNED_TO_GROUP") {
                this.assignedToGroup = true;
                this.submittingData = false;
                this.excludeAnimal = false;
                this.getUnGrouppedAnimals();
              } else if (stage == "MAINTAINANCE_MODE") {
                console.log("MAINTAINANCE_MODE");
                this.maintainanceMode = true;
              } else {
                this.maintainanceMode = false;
                this.assignedToGroup = false;
                this.submittingData = false;
                this.excludeAnimal = true;
              }
            }
          }
          this.isModeLoaded = true;
        })
        .catch(err => {
          console.log(err);
        });
    },
    async updateStage(stage) {
      await AnimalService.updateStage(stage)
        .then(res => {
          console.log("sss", res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    pageChange(t) {
      if (t) this.tableOptions.page = this.tableOptions.page + 1;
      else this.tableOptions.page = this.tableOptions.page - 1;

      this.excludeSelectedAnimals();
      this.getAnimalsData();
    },
    ungrouppedPageChange(t) {
      if (t)
        this.ungrouppedAnimalTableOptions.page =
          this.ungrouppedAnimalTableOptions.page + 1;
      else
        this.ungrouppedAnimalTableOptions.page =
          this.ungrouppedAnimalTableOptions.page - 1;

      this.getUnGrouppedAnimals();
    },
    searchEPDAnimal() {
      if (this.search == "") return;
      this.tableOptions.page = 1;
      this.getAnimalsData();
    },

    resetSearchOnEmpty() {
      if (this.search !== "") return;
      this.tableOptions.page = 1;
      this.getAnimalsData(true);
    },
    excludeSelectedAnimals() {
      this.excludedAnimals = this.selected.map(selectedAnimal => {
        return selectedAnimal.id;
      });

      this.excludedAnimalsCount = this.excludedAnimals.length;
      this.includedAnimalsCount = this.totalAnimals - this.excludedAnimalsCount;
      this.getAnimalsData();
    },
    formatDate(date, format = "YYYY-MM-DD") {
      const d = moment(date).format(format);
      if (d == "Invalid date") {
        return "";
      }
      return d;
    },
    resetFilter() {
      this.filterByDate = "";
      this.filterByStatus = "";
      this.filterByTrait = "";
      this.filterByFromDate = "";
      this.filterByFromDateMenu = false;
      this.filterByToDate = "";
      this.filterByToDateMenu = false;
      this.filterByFromBirthDate = "";
      this.filterByFromBirthDateMenu = false;
      this.filterByToBirthDate = "";
      this.filterByToBirthDateMenu = false;
      this.filterByBirthWeight = { min: 0, max: 0 };
      this.filterByWeaningWeight = { min: 0, max: 0 };
      this.filterByYearningWeight = { min: 0, max: 0 };
      this.filterByCarcassWeight = { min: 0, max: 0 };
    },

    async resendToUser() {
      const data = this.unGrouppedSelected?.length
        ? this.unGrouppedSelected
        : this.unGrouppedAnimals;
      let ungrouppedSelectedId = data.map(u => u.id);

      try {
        await AnimalService.resendAnimalsToUser(ungrouppedSelectedId).then(
          async res => {
            console.log(res);
          }
        );
      } catch (e) {
        console.log(e);
      }
    },
  },
  async created() {
    await this.getStage();
  },
  watch: {
    tableOptions: {
      handler() {
        this.getAnimalsData();
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.actions {
  margin-top: 2rem;
}

.group-stats {
  box-sizing: border-box;
  width: 100%;

  /* Orange/10 */

  background: #fff7ec;
  /* Orange/100 */

  border: 1px solid #ffb443;
  border-radius: 5px;
}

.stat-details {
  display: flex;
}
.filter-modal {
  width: 730px;
}
.animal-filter-by-date {
  background: #ffffff;
  border: 1px solid #00bd73;
  .v-input--radio-group__input {
    gap: 1rem;
    width: 80%;

    .v-radio {
      flex: 1 0 30%;
    }
  }
}
.filter-modal .v-text-field,
.filter-modal .v-select,
.filter-modal .v-radio {
  height: 40px;
  font-size: 10px !important;
  //   margin-right: 0px !important;
}
.filter-modal::v-deep label {
  font-size: 10px !important;
}
.filter-modal::v-deep
  .v-text-field.v-text-field--enclosed
  .v-text-field__details {
  display: none;
}
.right-lanel {
  margin-top: 10px;
}
.filter-modal::v-deep .custom {
  margin-top: 15px;
}
</style>
